module.exports = "/shared/img/tutorial-arrow-right.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/tutorial-arrow-right.png
// module id = 456
// module chunks = 13